export function Fetch(command = '', data = {}) {
    return fetch('/Remote/BPWS.asmx/' + command, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        mode: 'cors', // no-cors, *cors, same-origin
        credentials: 'omit', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
        .then(response => {
            if (response.ok) {
                return new Promise(function (resolve, reject) {
                    response.json().then(wrappedJSON => {
                        resolve(JSON.parse(wrappedJSON.d));
                    }).catch(error => {
                        reject(error);
                    });
                });
            } else
                throw { Status: response.status, Message: response.statusText };
        })
        .catch(error => {
            if (typeof error.Status === 'undefined')
                throw { Status: -1, Message: error };
            throw { Status: error.Status, Message: error.Message };
        })
}
export function XMLText2Json(xmlText2Json) {
    return JSON.parse(xmlText2Json.replace('<?xml version="1.0" encoding="utf-8"?>\r\n<string xmlns="http://tempuri.org/">', '').replace('</string>', ''));
}
export function BearingDegrees(lat1, long1, lat2, long2) {
    var degToRad = Math.PI / 180.0;

    var phi1 = lat1 * degToRad;
    var phi2 = lat2 * degToRad;
    var lam1 = long1 * degToRad;
    var lam2 = long2 * degToRad;

    return Math.atan2(Math.sin(lam2 - lam1) * Math.cos(phi2),
        Math.cos(phi1) * Math.sin(phi2) - Math.sin(phi1) * Math.cos(phi2) * Math.cos(lam2 - lam1)
    ) * 180 / Math.PI;
}
String.prototype.left = function (length) {
    return this.valueOf().substring(0, length);
};
String.prototype.right = function (length) {
    return this.valueOf().substr(this.valueOf().length - length)
};
String.prototype.show = function () {
    console.log(this);
};
function GoHomePage() {
    window.location.href = '/';
}
export function IsEmail(str) {
    var supported = 0;
    if (window.RegExp) {
        var tempStr = "a";
        var tempReg = new RegExp(tempStr);
        if (tempReg.test(tempStr))
            supported = 1;
    }
    if (!supported)
        return (str.indexOf(".") > 2) && (str.indexOf("@") > 0);
    var r1 = new RegExp("(@.*@)|(\\.\\.)|(@\\.)|(^\\.)");
    var r2 = new RegExp("^.+\\@(\\[?)[a-zA-Z0-9\\-\\.]+\\.([a-zA-Z]{2,3}|[0-9]{1,3})(\\]?)$");
    return (!r1.test(str) && r2.test(str));
}
